import _ from 'lodash';
import Image from 'next/image';

const AppLoadingState = ({ iteration }) => {
    const TextTemplate = () => {
        let sizes = [4, 3, 5, 1, 6, 2, 4, 3, 5, 6, 4, 6, 2, 4, 1, 5, 4, 6, 3, 7, 3, 2, 4, 3, 1];
        const start = (iteration * 5) % sizes.length;

        const textSizes = _.concat(_.slice(sizes, start), _.slice(sizes, 0, start));

        return textSizes.map((size, index) =>
            <span className={`placeholder col-${size} mr-1`} key={index}></span>
        );
    };

    return (
        <div className="col-12 col-md-6 col-xl-4">
            {/*<!-- Card -->*/}
            <div className="card card-fill">
                <div className="card-body mt-0">
                    {/*<!-- Blurred logo -->*/}
                    <Image
                        src="/img/logo.png"
                        alt="placeholder"
                        className="blur"
                        width={100}
                        height={32}
                    />

                    {/*<!-- Title -->*/}
                    <h1 className="card-title placeholder-glow h1">
                        <span className="placeholder col-8"></span>
                    </h1>

                    {/*<!-- Text -->*/}
                    <p className="card-text small placeholder-glow">
                        <TextTemplate />
                    </p>

                </div>
                <div className="card-footer card-footer-boxed">
                    <div className="row align-items-center">
                        <div className="col-6"></div>
                        <div className="col-6">
                            <a href="#" tabIndex="-1" className="btn btn-primary btn-sm disabled placeholder d-block"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AppLoadingState;
